(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mms-create-page"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    var iframe = document.querySelector('[data-mms-create-page-iframe]')
    var source = new URL('https://creator.mamamiya.store/?embed=1')
    var incoming = new URLSearchParams(window.location.search)
    ;['injectImage', 'product', 'design_id'].forEach(function (key) {
      var value = incoming.get(key)
      if (value) source.searchParams.set(key, value)
    })
    if (iframe) iframe.src = source.href

    // The embedded creator's X / ESC posts CLOSE (it cannot tell a full page from
    // a popup). On this dedicated page there is no dialog to close, so treat CLOSE
    // as "exit the studio" → back to the storefront home. Origin-gated so only the
    // creator iframe can trigger the navigation.
    window.addEventListener('message', function (e) {
      if (e.origin !== 'https://creator.mamamiya.store') return
      if ((e.data || {}).type === 'CLOSE') window.location.href = '/'
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mms-similar-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.currentScript
      ? document.currentScript.previousElementSibling
      : null;
    // Find the section the same way sections-rendering does — query by data attr
    const sections = document.querySelectorAll('.mms-similar[data-front-id]');
    sections.forEach(boot);

    function boot(section) {
      const frontId = (section.getAttribute('data-front-id') || '').trim();
      const rail = section.querySelector('[data-mms-similar-rail]');
      if (!frontId || !rail) {
        // Anchor product has no mamamiya mapping — keep section hidden.
        return;
      }
      if (!window.MMY || typeof window.MMY.fetchSimilarItems !== 'function') {
        return;
      }
      // Reveal section as soon as we have a real anchor — skeletons cover the wait.
      section.hidden = false;

      window.MMY.fetchSimilarItems(frontId, { limit: 8, rerank: true })
        .then(function (res) {
          if (!res.success || !res.items || res.items.length === 0) {
            // No embeds yet for this anchor — auto-hide instead of cluttering.
            section.hidden = true;
            return;
          }
          render(rail, res.items);
        })
        .catch(function () {
          section.hidden = true;
        });
    }

    function escapeHtml(s) {
      if (s == null) return '';
      const div = document.createElement('div');
      div.textContent = String(s);
      return div.innerHTML;
    }

    function formatPrice(usd) {
      if (typeof usd !== 'number' || isNaN(usd)) return '';
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: usd >= 100 ? 0 : 2
        }).format(usd);
      } catch (_) {
        return '$' + usd.toFixed(2);
      }
    }

    function hrefFor(item) {
      // Prefer Shopify product page when backend supplies a handle —
      // keeps users in commerce flow. Otherwise open creator-hub inspiration
      // so the card is never a dead click.
      if (item.shopify_handle) return '/products/' + encodeURIComponent(item.shopify_handle);
      if (item.handle) return '/products/' + encodeURIComponent(item.handle);
      return 'https://creator.mamamiya.store/?inspiration=' + encodeURIComponent(item.id);
    }

    function render(rail, items) {
      const frag = document.createDocumentFragment();
      items.forEach(function (item, idx) {
        const a = document.createElement('a');
        a.className = 'mms-similar__card';
        a.href = hrefFor(item);
        a.setAttribute('data-no-prerender', '');
        a.innerHTML =
          '<div class="mms-similar__img-wrap">' +
            '<img class="mms-similar__img" ' +
              'src="' + escapeHtml(item.main_image_url || '') + '" ' +
              'alt="' + escapeHtml(item.title || 'Design') + '" ' +
              'loading="' + (idx < 4 ? 'eager' : 'lazy') + '" ' +
              'decoding="async">' +
          '</div>' +
          '<div class="mms-similar__meta">' +
            '<p class="mms-similar__name">' + escapeHtml(item.title || '') + '</p>' +
            (typeof item.price_usd === 'number'
              ? '<p class="mms-similar__price">' + escapeHtml(formatPrice(item.price_usd)) + '</p>'
              : '') +
          '</div>';
        frag.appendChild(a);
      });
      rail.innerHTML = '';
      rail.appendChild(frag);
      rail.setAttribute('aria-busy', 'false');
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
